import { Link } from "@tanstack/react-router";
import { topicsFor } from "@/lib/taxonomy";

/**
 * Repository-backed topic links. Topics are derived only from the entity's own
 * author-written tags and text — nothing is invented, and the current page is
 * never linked to itself.
 */
export function TopicChips({
  tags,
  text,
  limit = 4,
  className = "",
}: {
  tags?: string[] | null;
  text?: string | null;
  limit?: number;
  className?: string;
}) {
  const topics = topicsFor({ tags: tags ?? [], text: text ?? "" }, limit);
  if (!topics.length) return null;

  return (
    <nav aria-label="Related topics" className={`flex flex-wrap items-center gap-2 ${className}`}>
      <span className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Topics</span>
      {topics.map((t) => (
        <Link
          key={t.slug}
          to="/topics/$slug"
          params={{ slug: t.slug }}
          className="rounded-full border border-gold/40 bg-gold/10 px-3 py-1 text-[11px] text-gold-luminous hover:bg-gold hover:text-obsidian"
        >
          {t.name}
        </Link>
      ))}
    </nav>
  );
}
